import * as yup from "yup";

const numberSchema = yup.string()
  .required()
  .default("")
  .matches(/^\d+$/, "Debe ser un número");

export default numberSchema;